// extracted by mini-css-extract-plugin
module.exports = {"container":"placeholder_container__3nFgU","icon":"placeholder_icon__3g-U4"};